<script>
import Colophon from './Colophon'
import Ice from './Ice'
import Lecture from './Lecture'
import Map from './Map'
import Meditation from './Meditation'
import NotFound from './NotFound'

export default {

  name: "Quadrant",

  components: {
    Map,
    Colophon,
    Meditation,
    Ice,
    Lecture,
    NotFound
  },

  props: [ 'quadrant', 'desiresMed' ],

  computed: {
    slug()     { return this.quadrant.slug },
    position() { return this.quadrant.Position },
  },

}

</script>

<template>
  <transition name="fade">
    <div
      aria-label="One of the five quadrants of the application"
      :id="slug + 'Container'"
      :class="['quadrant', position]"
      :tabindex="-1"
      v-if="$route.path.replace('/', '') == slug"
    >
      <Map
        v-if="slug == 'map'"
        :map="quadrant"
      />
      <Colophon
        v-else-if="slug == 'colophon'"
        :colophon="quadrant"
      />
      <Meditation
        v-else-if="slug == 'meditation' && desiresMed"
        :meditation="quadrant"
      />
      <Ice
        v-else-if="slug == 'ice'"
        :ice="quadrant"
      />
      <Lecture
        v-else-if="slug == 'lecture'"
        :lecture="quadrant"
      />
      <NotFound
        v-else
        :notfound="quadrant"
      />
    </div>
  </transition>
</template>

<style scoped>

h1 {
  margin: 1em;
}

.quadrant {
  position: absolute;
  height: calc(100% / 3);
  width: calc(100% / 3);
  border-radius: 0;
  overflow: hidden;
  transition:
    filter var(--slow) ease-out,
    border-radius var(--slow) ease,
    opacity var(--slow) ease-out,
    transform var(--slow) ease-out
  ;
}
.quadrant.center {
  top  : calc(100% / 3);
  left : calc(100% / 3);
}
.quadrant.top {
  top  : 0%;
  left : calc(100% / 3);
}
.quadrant.right {
  top  : calc(100% / 3);
  left : calc(2 * 100% / 3);
}
.quadrant.bottom {
  top  : calc(2 * 100% / 3);
  left : calc(100% / 3);
}
.quadrant.left {
  top  : calc(100% / 3);
  left : 0;
}
.quadrant.topleft {
  top  : 0;
  left : 0;
}

.routing .quadrant {
  filter: blur(30px);
  transform: scale(0.9);
  border-radius: 5em;
  transition:
    filter var(--fast) ease-in,
    border-radius var(--slow) ease,
    opacity var(--slow) ease-in,
    transform var(--slow) ease
  ;
}


</style>
